<template>
  <div class="dataPlatform-layout">
    <MenuBar/>
    <div class="main-container">
    <Navbar/>
      <div class="dataPlatform-main">
        <div class="dataPlatform-content">
            <router-view />
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
  export default {
    name:'',
    components: {
        MenuBar: () => import("./components/MenuBar/index.vue"),
        Navbar: () => import("./components/Navbar/index.vue"),
    },
    props:[''],
    data () {
      return {

      };
    },
    watch: {},
    created() {},
    beforeMount() {},
    mounted() {},
    methods: {},
    computed: {}
  }
</script>
<style lang='scss' scoped>
@import "@/style/reset.css";
.dataPlatform-layout{
    width: 100%;
    height: 100%;
    display: flex;
    gap: 25px;
    background-color: #F4F6F9;
    .main-container{
        width: 100%;
        height: 100%;
      .dataPlatform-main{
          flex: 1;
          width: calc(100% - 25px);
          height: calc(100% - 60px);
          padding: 0px 25px 0px 0px;
          .dataPlatform-content{
              height: calc(100% - 25px);
              background-color: #fff;
              border-radius: 20px 20px 20px 20px;
          }
      }
    }
    ::v-deep .el-form{
      .el-form-item{
        text-align: left;
        .el-form-item__label{
          font-weight: bold;
          font-size: 14px;
          color: #7E7E7E;
          line-height: 20px;
        }
      }
    }
}
</style>